
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { Request } from "@/api/request";

export default defineComponent({
    name: "AppointmentAdd",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["运营管理", "预约设置"]);
        const route = useRoute();
        const router = useRouter();
        let form = ref({
                start_time: "",
                end_time: "",
                project_type_id: '',
                people: "",
                name: "",
                sort: 1,
            } as any),
            timeList = ref([]),
            project = ref([]),
            formRef = ref(null),
            formLoading = ref(false),
            id: any = null,
            rules = {
                name: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "change",
                    },
                ],
                start_time: [
                    {
                        required: true,
                        message: "请选择开始时间",
                        trigger: "change",
                    },
                ],
                end_time: [
                    {
                        required: true,
                        message: "请选择结束时间",
                        trigger: "change",
                    },
                ],
                project_type_id: [
                    {
                        required: true,
                        message: "请选择服务类型",
                        trigger: "change",
                    },
                ],
                people: [
                    {
                        required: true,
                        message: "请输入可预约次数",
                        trigger: "change",
                    },
                ],
            };

        let onSubmit = () => {
            (formRef.value as any).validate((valid: boolean) => {
                if (valid) {
                    let data = {
                            ...form.value,
                        },
                        url = "adminapi/Preabout/createPreabout";
                    if (Object.keys(route.query).length > 0) {
                        data = {
                            ...data,
                            id,
                        };
                        url = "adminapi/Preabout/upedit";
                    }

                    Request.axiosInstance({
                        url,
                        data,
                    }).then((res) => {
                        if (res.status == 202) {
                            router.back();
                        }
                    });
                }
            });
        };

        onMounted(() => {
            Request.axiosInstance({
                url: "adminapi/Preabout/dateTime",
            }).then((res: any) => {
                timeList.value = res?.content?.list || [];
            });
            Request.axiosInstance({
                url: "adminapi/ProjectType/list",
                data: {
                    status: 1,
                },
            }).then((res: any) => {
                project.value = res?.content?.list || [];
            });
            if (Object.keys(route.query).length > 0) {
                formLoading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Preabout/preaboutInfo",
                    data: {
                        id: route.query.id,
                    },
                }).then((res: any) => {
                    formLoading.value = false;
                    if (res.status == 200) {
                        Object.keys(form.value).forEach((key) => {
                            form.value[key] = res.content.info[key];
                        });
                        id = res.content.info.id;
                    }
                });
            }
        });

        return {
            form,
            formRef,
            rules,
            formLoading,
            onSubmit,
            timeList,
            project,
        };
    },
});
